/**
 * Created by Stefen Suhat on 5/22/2017.
 */

const primary = { main: '#F6404F' };
const secondary = { main: '#0093FF' };
const info = { main: '#0376E3' };
const success = { main: '#73D500' };
const warning = { main: '#FFDD00' };
const purple = '#C27AEB';
const red = '#FF4A7A';
const cyan = '#03C4C6';
const gray = '#4B515E';
const dark = '#1A1D24';
const error = { main: '#FF4A7A' };
const divider = '#30333A';
const background = { paper: '#1E2127', default: '#1B1D24' };
// const blue= '#5E50F9';
// const indigo = '#6610F2';
// const pink = '#E91E63';
// const orange = '#F2A654';
// const green= '#46c35f';
// const teal = '#58D8A3';

export {
    primary,
    secondary,
    divider,
    background,
    success,
    info,
    error,
    red,
    cyan,
    gray,
    warning,
    purple,
    dark,
    // indigo,
    // pink,
    // orange,
    // teal,
};
